module.exports = __webpack_public_path__ + "static/media/p4_token.4c171bca.png";